import { jsx as _jsx } from "react/jsx-runtime";
import { Contrast } from "../../../types/general.types";
import { SectionSizes } from "./constants";
import StyledSection from "./Section.style";
const Section = ({ children, size = SectionSizes.section_1, contrast = Contrast.default, ...props }) => (_jsx(StyledSection, { size: size, contrast: contrast, ...props, children: children }));
export default Section;
//# sourceMappingURL=Section.js.map